import {Route} from 'react-router';
import React from 'react';

import {addGenericErrorToast} from '@albert-io/atomic';
import appActions from 'client/AppActions';
import {callAction} from 'client/framework';
import {clearSkillPathCache} from './StudentSkillPath/useStudentSkillPath';
import {getClassroomsQuery} from 'client/Classrooms/StudentDashboard/StudentDashboard.queries.js';
import {getFeatureFlagStatus} from 'client/components/FeatureFlag/featureFlag.utils';
import sessionStore from 'client/Session/SessionStore';
import StudentHomepage from './StudentHomepage';
import StudentHomepageAssignmentsTabContent from './StudentAssignments/StudentAssignments';
import {StudentIndependentPractice} from './StudentIndependentPractice/StudentIndependentPractice';
import {StudentSkillPath} from './StudentSkillPath/StudentSkillPath';
import Welcome from './Welcome';

const StudentHomepageRoutes = (
  <Route
    component={StudentHomepage}
    onEnter={(nextState, replace, callback) => {
      callAction(appActions.SET_FOOTER_DISPLAY, false);

      if (!sessionStore.hasValidSession()) {
        replace('/log-in');
        callback?.();
      } else if (sessionStore.hasValidSession() && !sessionStore.isStudent()) {
        replace('/classes');
        callback?.();
      } else if (nextState.location.pathname !== '/home') {
        callback?.();
      } else {
        getFeatureFlagStatus('new_student_dashboard')
          .then((isFlagEnabled) => {
            if (isFlagEnabled) {
              const query = getClassroomsQuery(sessionStore.getUserId());

              query.getResourcePromise().then((classrooms) => {
                if (classrooms.size === 0) {
                  replace('/home/welcome');
                } else {
                  replace('/home/assignments');
                }

                callback?.();
              });
            } else {
              replace('/classes');
              callback?.();
            }
          })
          .catch(() => {
            addGenericErrorToast();
            callback?.();
          });
      }
    }}
    onLeave={() => {
      clearSkillPathCache();
      callAction(appActions.SET_FOOTER_DISPLAY, true);
    }}
    path='home'
  >
    <Route
      component={StudentHomepageAssignmentsTabContent}
      path='(class/:classroomId/)assignments'
    />
    <Route
      component={StudentIndependentPractice}
      path='(class/:classroomId/)independent-practice'
    />
    <Route component={StudentSkillPath} path='(class/:classroomId/)skill-path' />
    <Route component={Welcome} path='welcome' />
  </Route>
);

export default StudentHomepageRoutes;
